import {
  LayoutDashboard,
  Users,
  Ambulance,
  ClipboardCheck,
  LayoutPanelTop,
  Hospital,
  Settings,
  Rss,
  Image,
  Banknote,
  ClipboardList,
  Tag,
  Wrench
} from 'lucide-react';

export function getUserAndOrgData() {
  const userRaw = localStorage.getItem('user');
  const selectedOrgRaw = localStorage.getItem('selectedOrg');
  const user = userRaw ? JSON.parse(userRaw) : null;
  const orgId = selectedOrgRaw ? parseInt(selectedOrgRaw, 10) : null;
  return { user, orgId };
}

export function getPermissionLevel(menuId) {
  const { user, orgId } = getUserAndOrgData();
  const ente = user?.user?.enti?.find((e) => e.id_ente === orgId);
  const perm = ente?.permessi_ente?.find((p) => p.menu_id === menuId);
  return perm?.tipo ?? 0; // default: Nessun accesso
}

export function hasPermission(menuId, requiredLevel = 1) {
  return getPermissionLevel(menuId) >= requiredLevel;
}

export function filterNavItemsByPermissions(navItems) {
  return navItems.filter((nav) => {
    // Rendi visibile la Dashboard a tutti gli utenti autenticati
    if (nav.path === '/dashboard') return true;

    // Rendi visibili gli item solo se si hanno i permessi richiesti
    return hasPermission(nav.id, nav.tipo);
  });
}

// (N)= Numero del menù N= Livello del permesso richiesto
export function canEditUtenti() {
  return isSuperadmin() || getPermissionLevel(4) >= 2;
}

export function canEditVehicles() {
  return isSuperadmin() || getPermissionLevel(3) >= 2;
}

export function canEditCategory() {
  return isSuperadmin() || getPermissionLevel(2) >= 2;
}

export function isSuperadmin() {
  return JSON.parse(localStorage.getItem('isSuperadmin')) === true;
}

// ✅ VERSIONE DINAMICA: passare selectedOrg da React Context
export function getNavItems(selectedOrg) {
  return [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/dashboard', tipo: 1, id: 1 },
    { label: 'Categorie', icon: LayoutPanelTop, path: '/categorie', tipo: 1, id: 2 },
    { label: 'Convenzioni', icon: Tag, path: '/convenzioni', tipo: 1, id: 2 },
    { label: 'Risorse', icon: Ambulance, path: '/risorse', tipo: 1, id: 3 },
    { label: 'Problemi', icon: Wrench, path: '/problemi', tipo: 1, id: 3 },
    { label: 'Utenti', icon: Users, path: '/utenti', tipo: 1, id: 4 },
    { label: 'Checklist', icon: ClipboardCheck, path: '/checklist', tipo: 1, id: 5 },
    { label: 'Immagini', icon: Image, path: `/photo`, tipo: 1, id: 3 },

    { label: 'Impostazioni', icon: Settings, path: `/org/${selectedOrg}`, tipo: 1, id: 8 },

    { label: 'Organizzazioni', icon: Hospital, path: '/org', tipo: 2, id: 9, isSuperadmin: true },
    { label: 'Marketplace', icon: Banknote, path: `/org/${selectedOrg}/order`, tipo: 2, id: 9, isSuperadmin: true},
    { label: 'Orders', icon: ClipboardList, path: `/org/${selectedOrg}/orders`, tipo: 2, id: 9, isSuperadmin: true},
    { label: 'Changelog app', icon: Rss, path: '/changelog', tipo: 1, id: 1 },
  ];
}
